import { styled } from '@mui/material/styles';
import {
    Alert,
    Box,
    Button,
    IconButton,
    FormControl,
    LinearProgress,
    Paper,
    TableCell,
    TableContainer,
    TextField,
    Typography,
} from '@mui/material';

export { InviteButton as AddPlanButton } from 'components/views/inviteUser/InviteUserDialog/InviteUserDialog.styles';

export {
    CancelButton as RowCancelButton,
    SaveButton as RowSaveButton,
} from 'components/views/profile/DisplayNameSection/DisplayNameSection.styles';

const INPUT_BORDER_RADIUS = 12;

export const LoaderContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
}));

export const SectionAlert = styled(Alert)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

export const HeaderTitle = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

export const SectionTitle = styled(Typography)({
    fontWeight: 600,
});

export const SubscriptionPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(4),
}));

export const SubscriptionDetails = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
}));

export const LabelText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

export const PlanNameText = styled(Typography)({
    fontWeight: 600,
});

export const StorageContainer = styled(Box)({
    flexGrow: 1,
    minWidth: 240,
    maxWidth: 400,
});

export const StorageProgress = styled(LinearProgress)(({ theme }) => ({
    marginTop: theme.spacing(1),
    height: 8,
    borderRadius: 4,
}));

export const PlanSelectFormControl = styled(FormControl)({
    minWidth: 240,
    '& .MuiOutlinedInput-root': {
        borderRadius: INPUT_BORDER_RADIUS,
    },
});

export const TableHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
}));

export const HintText = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
}));

export const PlansTableContainer = styled(TableContainer)(({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    width: 'auto',
    '& .MuiTableCell-head': {
        fontWeight: 600,
    },
})) as typeof TableContainer;

export const NameCell = styled(TableCell)({
    minWidth: 160,
});

const CODE_COLUMN_WIDTH = '5rem';

export const CodeCell = styled(TableCell)({
    width: CODE_COLUMN_WIDTH,
    maxWidth: CODE_COLUMN_WIDTH,
    '& .MuiTypography-root, & .MuiTextField-root': {
        width: CODE_COLUMN_WIDTH,
        maxWidth: CODE_COLUMN_WIDTH,
    },
    '& .MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

export const StorageCell = styled(TableCell)({
    minWidth: 100,
});

export const LimitCell = styled(TableCell)({
    minWidth: 90,
});

export const ChipsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
}));

export const RowActions = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    whiteSpace: 'nowrap',
});

export const RowEditButton = styled(Button)(({ theme }) => ({
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
}));

export const RowDeleteButton = styled(IconButton)({
    marginRight: 'auto',
});

export const FullWidthTextField = styled(TextField)({
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: INPUT_BORDER_RADIUS,
    },
});
